module.exports = __webpack_public_path__ + "img/btn.20938767.png";